import React from "react";
import Icon from "../Icon";
import { Card, Head, IconBadge, Title, Sub } from "./styles";

interface CardSectionProps {
  icon: string;
  title: string;
  sub?: string;
  children: React.ReactNode;
}

export default function CardSection({ icon, title, sub, children }: CardSectionProps) {
  return (
    <Card>
      <Head>
        <IconBadge>
          <Icon name={icon} size={18} />
        </IconBadge>
        <div>
          <Title>{title}</Title>
          {sub && <Sub>{sub}</Sub>}
        </div>
      </Head>
      {children}
    </Card>
  );
}
